import { markRaw } from 'vue';

class LvImageTypeInternal {
  cssName: string;
  constructor ({ cssName }: { cssName: string }) {
    this.cssName = cssName;
  }
}

export const LV_IMG_TYPE_DEFAULT = markRaw(new LvImageTypeInternal({
  cssName: 'default',
}));
export const LV_IMG_TYPE_VARIANT = markRaw(new LvImageTypeInternal({
  cssName: 'variant',
}));
export const LV_IMG_TYPE_YOUTUBE = markRaw(new LvImageTypeInternal({
  cssName: 'youtube',
}));
export const LV_IMG_TYPE_CATEGORY = markRaw(new LvImageTypeInternal({
  cssName: 'category',
}));
export const LV_IMG_TYPE_BANNER = markRaw(new LvImageTypeInternal({
  cssName: 'banner',
}));

export type LvImageType = (
  | typeof LV_IMG_TYPE_DEFAULT
  | typeof LV_IMG_TYPE_VARIANT
  | typeof LV_IMG_TYPE_YOUTUBE
  | typeof LV_IMG_TYPE_CATEGORY
  | typeof LV_IMG_TYPE_BANNER
);
